import React, { useState, useEffect, useContext, useCallback } from 'react'
import { useNavigate } from 'react-router-dom';
import './modal.scss';
import { MainContext } from '../../../App';

import MultilevelCategoryMenu from '../../NestedCatMenu/MultilevelCategoryMenu';
 
export default function Modal() {

    const navigate = useNavigate();

    const [
        isLoading,
        setIsLoading,
        userRole,
        setUserRole,
        userEmail,
        setUserEmail,
        categories,
        setCategories,
        modal,
        setModal,
    ] = useContext(MainContext);

    const toggleModal = () => {
        setModal(p => !p);
    }

    useEffect(() => {
        // Запрос данных с сервера
        fetch('/api/categories')
            .then((response) => response.json())
            .then((data) => {
                setCategories(data); // Сразу используем данные в иерархическом формате
            })
            .catch((error) => console.error('Ошибка загрузки категорий:', error));
    }, []);

    const handleCategorySelect = useCallback(
        (id) => {
            navigate(`/products/${id}`);
            setModal(false);
        },
        [navigate, setModal]
    );

    return (
        <>
            <div className={`overlay ${modal ? "active" : ""}`} onClick={toggleModal}>
                <div
                    className="modal"
                    onClick={(e) => e.stopPropagation()}
                >
                    <MultilevelCategoryMenu 
                        categories={categories} 
                        onCategorySelect={handleCategorySelect}
                        isDropDown={false}
                    />

                    <span className="close-modal" onClick={toggleModal}>
                        &times;
                    </span>
                </div>
            </div>
        </>
    );
}
 